<template>
  <span class="bookmark-popup-trigger" @click="openPopup()"></span>
  <div class="view-book">
    <div v-if="book && book.pdf_url" class="pdf-wrapper">
      <VPdfViewer
          ref="vpvRef"
          v-if="book.pdf_url"
          :toolbarOptions="toolbarOptions"
          :src="book.pdf_url"
          @loaded="onLoaded"
          @pageChanged="pageUpdated"
      />
    </div>

    <p v-else>Boek laden...</p>
  </div>

  <div class="bookmark-popup" :class="{open: bookmarkPopupOpen}">
    <span class="overlay" @click="closePopup()"></span>

    <div class="content">
      <CreateBookmarkForm
          @created='closePopup()'
          v-if="book && book.pdf_url"
          :book_id="book.id"
          :book_name="book.name"
          :page_number="getPageNumber()"
      ></CreateBookmarkForm>
    </div>
  </div>
</template>

<script>
import {ref, computed} from 'vue';
import {mapActions} from 'vuex';
import {VPdfViewer, useLicense} from '@vue-pdf-viewer/viewer';
import {Capacitor} from '@capacitor/core';
import * as pdfjsLib from 'pdfjs-dist';

const worker = new Worker(
    new URL('pdfjs-dist/build/pdf.worker.js', import.meta.url),
    { type: 'module' }
);

pdfjsLib.GlobalWorkerOptions.workerPort = worker;

import CreateBookmarkForm from "../bookmarks/CreateBookmarkForm.vue";

export default {
  name: "ViewBook",
  setup() {
    const vpvRef = ref();
    const pageControl = computed(() => vpvRef.value?.pageControl);
    return {
      vpvRef,
      pageControl,
      getPageNumber: () => {
        const pageNumber = pageControl.value?.currentPage ?? null; // Return null if not initialized
        return pageNumber;
      },
    };
  },
  components: {
    VPdfViewer,
    CreateBookmarkForm,
  },
  beforeMount() {
    const licenseKey = import.meta.env.VITE_VPV_LICENSE ?? "your-VPV-license-key";
    useLicense(licenseKey);
  },
  data() {
    return {
      book: {},
      bookmarkPopupOpen: false,
      initialPage: 1,
      toolbarOptions: {
        fullscreen: false,
        jumpNavigatable: false,
        pointerSwitchable: false,
        printable: false,
        downloadable: false,
        rotatable: false,
        docPropertiesEnabled: false,
        navigatable: false,
        scrollingSwitchable: false,
        sidebarEnable: false,
        themeSwitchable: false,
        thumbnailViewable: false,
        newFileOpenable: false,
        pageViewSwitchable: false,
      },
      lastPageSent: null, // Track the last page sent to the server
      trackingInterval: null, // Store the interval ID for cleanup
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('book', ['getBook', 'setBookPageInformation']),

    init() {
      const bookId = this.$route.params.id;
      this.initialPage = this.$route.query.page ? parseInt(this.$route.query.page) : 2;

      if(this.initialPage === 1) {
        this.initialPage = 2;
      }

      this.getBook(bookId).then((response) => {
        this.book = response;
      });
    },

    onLoaded() {
      this.pageControl.goToPage(this.initialPage);
    },

    pageUpdated(newPage) {
      if (newPage !== null && newPage !== this.lastPageSent) {
        this.updatePageInformation(newPage);
      }
    },

    updatePageInformation(currentPage) {
      this.setBookPageInformation({
        book_id: this.book.id,
        current_page: currentPage,
      })
          .then(() => {
            this.lastPageSent = currentPage;
          })
          .catch((error) => {
            console.error('Failed to update page information', error);
          });
    },

    openPopup() {
      this.bookmarkPopupOpen = true;
    },

    closePopup() {
      this.bookmarkPopupOpen = false;
    }
  }
};
</script>
